import { render, staticRenderFns } from "./PaniereDetailsDialog.vue?vue&type=template&id=386d599f&scoped=true"
import script from "./PaniereDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PaniereDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d599f",
  null
  
)

export default component.exports